<template>
  <div class="topbg">
    <div class="v100 top">
      <div class="w980">
        <a
          class="go_vroot fl"
          href="http://www.iroot.com"
          target="_blank"
          title="Get iRoot for english"
        ></a>
        <div class="fr fs12">
          欢迎来到刷机大师
          <span id="userInfoPartial"></span>
        </div>
      </div>
    </div>
    <div class="w980 head mt18">
      <div class="fl logo">
        <router-link :to="'/'">
          <img alt="刷机大师官网" src="@/assets/images/logo.jpg" />
        </router-link>
      </div>
      <div class="nav fr mt2">
        <dl onmouseout="this.className=''" onmouseover="this.className='aHover1'">
          <dt id="dt_0" class="home">
            <router-link :to="'/'">
              <span>首页</span>
            </router-link>
          </dt>
        </dl>
        <dl onmouseout="this.className=''" onmouseover="this.className='aHover2'">
          <dt id="dt_1" class="product">
            <a href="#" title="产品">
              <span>产品</span>
            </a>
          </dt>
          <dd class="con">
            <router-link :to="'/function/romasterlab'">刷机大师(PC)</router-link>
            <router-link :to="'/function/andromaster'">刷机大师(手机)</router-link>
            <router-link :to="'/function/vroot'">ROOT大师(PC)</router-link>
            <router-link :to="'/function/irootm'">ROOT大师(手机)</router-link>
            <router-link :to="'/function/supercleaner'">安卓清理大师</router-link>
            <router-link :to="'/function/onelocker'">锁大师</router-link>
            <router-link :to="'/function/appcool'">应用酷</router-link>
            <router-link :to="'/function/wp8launcher'">WP桌面</router-link>
          </dd>
        </dl>
        <dl onmouseout="this.className=''" onmouseover="this.className='aHover3'">
          <dt id="dt_2" class="help">
            <a href="/" title="教程帮助">
              <span>教程帮助</span>
            </a>
          </dt>
        </dl>
        <dl onmouseout="this.className=''" onmouseover="this.className='aHover4'">
          <dt id="dt_3" class="Rom">
            <a href="http://www.romleyuan.com" target="_blank" title="ROM下载">
              <span>ROM下载</span>
            </a>
          </dt>
        </dl> 
        <dl onmouseout="this.className=''" onmouseover="this.className='aHover5'">
          <dt id="dt_4" class="about">
            <a href="/" title="关于我们">
              <span>关于我们</span>
            </a>
          </dt>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "XHeader"
};
</script>


// WEBPACK FOOTER //
// src/components/shared/XHeader.vue